import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DeviceActions } from './devices.actions';
import { DeviceService } from '../../services/device.service';
import { extractErrorMessage } from '../../utils/error.utils';

@Injectable()
export class DevicesEffects {
  private actions$ = inject(Actions);
  private svc = inject(DeviceService);

  loadDevices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.loadDevices),
      mergeMap(({ customerId }) => this.svc.getAll(customerId).pipe(
        map(devices => DeviceActions.loadDevicesSuccess({ devices })),
        catchError(err => of(DeviceActions.loadDevicesFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  loadDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.loadDevice),
      mergeMap(({ id }) => this.svc.getById(id).pipe(
        map(device => DeviceActions.loadDeviceSuccess({ device })),
        catchError(err => of(DeviceActions.deviceFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  createDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.createDevice),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(device => DeviceActions.createDeviceSuccess({ device })),
        catchError(err => of(DeviceActions.deviceFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  updateDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.updateDevice),
      mergeMap(({ id, dto }) => this.svc.update(id, dto).pipe(
        map(device => DeviceActions.updateDeviceSuccess({ device })),
        catchError(err => of(DeviceActions.deviceFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );

  deleteDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.deleteDevice),
      mergeMap(({ id }) => this.svc.delete(id).pipe(
        map(() => DeviceActions.deleteDeviceSuccess({ id })),
        catchError(err => of(DeviceActions.deviceFailure({ error: extractErrorMessage(err) })))
      ))
    )
  );
}
